import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "../../functions/api";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { Typography, Box, Button, Table, TableRow, TableBody, TableCell, TableContainer, Paper, TableHead, TextField, Grid } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import { useMessage } from "../../context/message-context";
function EntgeltDetails(props) {
  const { t } = useTranslation();
  const { client, accessToken, program, ansprung, payroll } = props;
  const [isLoading, setIsLoading] = useState(false);
  const { hideMessage, showErrorMessage } = useMessage();
  
  useEffect(() => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "LWEB01",
      statement: "LADE_DETAILS",
      payroll: payroll,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, initCB, errorCb);
    // eslint-disable-next-line
  }, []);
  const errorCb = () => {
    setIsLoading(false);
    showErrorMessage(t("Inhalt konnte nicht geladen werden. Bitte versuchen Sie es erneut."));
  };
  const initCB = (response) => {
    if (response.status === 200) {
      setIsLoading(false);
    }
    setIsLoading(false);
    showErrorMessage(t("Inhalt konnte nicht geladen werden. Bitte versuchen Sie es erneut."));
  };

  if (isLoading) {
    return <LoadingComponent />;
  }
  return <></>;
}
export default EntgeltDetails;
